import { SITE } from "@/constants/testIds";

const IMG =
  "https://images.unsplash.com/photo-1688437307687-fe226bddfab1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxmcmlkYXklMjBldmVuaW5nJTIwZGlubmVyJTIwdGFibGUlMjBjYW5kbGVzfGVufDB8fHx8MTc4MDkzMTk2N3ww&ixlib=rb-4.1.0&q=85";

export const Gratitude = () => {
  return (
    <section
      id="gratitude"
      data-testid={SITE.gratitudeSection}
      className="relative py-24 sm:py-32 overflow-hidden"
    >
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url(${IMG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        aria-hidden
      />
      <div className="absolute inset-0 bg-background/85 backdrop-blur-[2px]" aria-hidden />
      <div className="absolute inset-0 bg-gradient-to-b from-background/60 via-background/85 to-background" aria-hidden />

      <div className="relative max-w-3xl mx-auto px-6 lg:px-12 text-center">
        <p className="text-xs uppercase tracking-[0.32em] text-primary/90 mb-5">
          With Gratitude
        </p>
        <h2 className="font-serif text-4xl sm:text-5xl text-foreground leading-tight tracking-tight text-balance">
          To the hands that kept
          <br />
          <span className="italic text-primary">the candle lit.</span>
        </h2>
        <div className="gold-rule w-24 mx-auto my-10" />
        <p className="text-foreground/85 text-base sm:text-lg leading-[1.85] max-w-2xl mx-auto">
          This song is offered with gratitude — to America, to families who
          carried the light across oceans, to teachers and mentors who chose to
          believe in a child, to communities who set an extra place at the
          table, to artists who give shape to what we feel, to public servants
          who keep the lamps trimmed, and to neighbors who, without ceremony,
          make a country feel like home.
        </p>
      </div>
    </section>
  );
};
